module.exports = __webpack_public_path__ + "static/img/tuzheng_011.5df30a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tuzheng_011.png
// module id = lCYN
// module chunks = 1